import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';


// Header Component

export const Header = ({ isMenuOpen, setIsMenuOpen }) => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Plans', href: '/plans/' },
    { name: 'Services', href: '/services/' },
    { name: 'Features', href: '/features/' },
    { name: 'Blog', href: '/blog/' },
    { name: 'About Us', href: '/about/' },
    { name: 'Contact Us', href: '/contact/' },
  ];

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <nav className="nav-container">
        <div className="nav-content">
          <Link to="/" className="logo">
            <span className="logo-text">InstaHeed</span>
          </Link>
          
          <div className="nav-links desktop-nav">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`nav-link ${location.pathname === item.href ? 'active' : ''}`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <div className="nav-actions">
            <Link to="/services" className="btn"><button  className="cta-button primary">Book A Call</button></Link>
            <button 
              className="mobile-menu-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
          <div className="mobile-menu-content">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`mobile-nav-link ${location.pathname === item.href ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
              <button  className="cta-button primary"><Link to="/services" className="btn">Book A Call</Link></button>
          </div>
        </div>
      </nav>
    </header>
  );
};

// Footer Component
export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Our Motto</h3>
            <p className="footer-text">
              "Welcome to India's first Instagram consultation service where your online presence is our priority! As pioneers in the field, we are the first Instagram consultation service startup in the country, dedicated to delivering exceptional solutions for your Instagram needs."
            </p>
            <div className="social-links">
              <a href=" https://x.com/VikrantGautam01?t=job6x-p1uTZU9ee5Y4HqGg&s=09" target="_blank" rel="noreferrer" className="social-link">
                <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/instaheed?igsh=ajI5bnNrbWUyd256" target="_blank" rel="noreferrer" className="social-link">
                <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a href="https://youtube.com/@technologyprashant?si=cnPdYHPIFTa5Kb1q" target="_blank" rel="noreferrer" className="social-link">
                <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/plans" className="footer-link">Plans</Link></li>
              <li><Link to="/services" className="footer-link">Services</Link></li>
              <li><Link to="/features" className="footer-link">Features</Link></li>
              <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" className="footer-link">Terms and Conditions</Link></li>
              <li><Link to="/refund-and-cancellation-policy" className="footer-link">Refund and Cancellation Policy</Link></li>
              <li><Link to="/blog" className="footer-link">Blog</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Services</h3>
            <ul className="footer-links">
              <li><Link to="/services" className="footer-link">My Instagram Account Access Problem ?</Link></li>
              <li><Link to="/services" className="footer-link">My Instagram Upload Your ID Problem ?</Link></li>
              <li><Link to="/services" className="footer-link">My Instagram Suspended Problem ?</Link></li>
              <li><Link to="/services" className="footer-link">My Instagram Showing Deleted Problem ?</Link></li>
              <li><Link to="/services" className="footer-link">Why You face Problem related to boost post & running ads ?</Link></li>
              <li><Link to="/services" className="footer-link">We Limit how often you can do certain things to on Instagram protect our community Problem ?</Link></li>
              <li><Link to="/services" className="footer-link">Why My Account is Shadowban Problem ?</Link></li>
              <li><Link to="/services" className="footer-link">How to Contact Meta Pro Team Problem ?</Link></li>
              <li><Link to="/services" className="footer-link">My Account Face Copyright Strike Problem ?</Link></li>
              <li><Link to="/services" className="footer-link">Why I'm Not Able To Retraction The Copyright Strike Problem ?</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">© 2025 - All Right Reserved. InstaHeed is not affiliated with Instagram , Facebook or Meta.</p>
            <p className="disclaimer">All Instagram and Facebook logos and trademarks displayed on this application are property of Instagram ® or Facebook ® respectively. Being We're an Instagram Consultantion Service & Growth Agency.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Home Page Component

// Plans Page Component

// Services Page Component

// Features Page Component
export const Features = () => {
  const features = [
    {
      title: "Experience",
      description: "Years of expertise in Instagram security and growth strategies",
      icon: "🎯"
    },
    {
      title: "Expertise",
      description: "Specialized knowledge in Instagram algorithms and best practices",
      icon: "💡"
    },
    {
      title: "Confidentiality",
      description: "Your account information is always kept secure and private",
      icon: "🔒"
    },
    {
      title: "Reliability",
      description: "Consistent and dependable service you can trust",
      icon: "⚡"
    },
    {
      title: "Innovation",
      description: "Cutting-edge solutions for modern Instagram challenges",
      icon: "🚀"
    },
    {
      title: "24/7 Support",
      description: "Round-the-clock assistance whenever you need it",
      icon: "🕐"
    }
  ];

  const testimonials = [
    {
      name: "Radhika Jakhotia",
      role: "Content Creator",
      content: "InstaHeed helped me secure my account and grow my following organically. Their support team is amazing!",
      rating: 5
    },
    {
      name: "Shashank Sharma",
      role: "Agency Owner",
      content: "We've been using InstaHeed for our clients and the results speak for themselves. Highly recommended!",
      rating: 5
    },
    {
      name: "Anusha Raj",
      role: "Influencer",
      content: "The security audit revealed vulnerabilities I didn't know existed. Thanks to InstaHeed, my account is now bulletproof.",
      rating: 5
    }
  ];

  return (
    <div className="features-page">
      <div className="container">
        <div className="features-header">
          <h1 className="features-title">Why Choose InstaHeed?</h1>
          <p className="features-subtitle">
            Discover the features that make InstaHeed the leading Instagram security and growth consultation service.
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="features-page">
  <div className="container">
    
    {/* Testimonials Section */}
    <div className="testimonials-section">
      <h2 className="testimonials-title">What Our Clients Say</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <div className="testimonial-rating">
              {[...Array(testimonial.rating)].map((_, i) => (
                <span key={i} className="star">⭐</span>
              ))}
            </div>
            <p className="testimonial-content">"{testimonial.content}"</p>
            <div className="testimonial-author">
              <strong>{testimonial.name}</strong>
              <span>{testimonial.role}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</div>


        <div className="features-cta">
          <h2>Ready to Secure Your Instagram?</h2>
          <p>Join thousands of satisfied clients who trust InstaHeed with their Instagram security and growth Consultation.</p>
          <div className="features-buttons">
            <Link to="/plans" className="cta-button first">Get Started Today</Link>
            <Link to="/contact" className="cta-button secondary">Book A Call</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

// Contact Page Component
export const Contact = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };


  const scriptURL = 'https://script.google.com/macros/s/AKfycbyB7ePk4EeGVXMO0olSZWKuOdqqQ80BFcECouGmaC-ZP-p0MzNX3EoLmzYbbFpWyaEY/exec';

const handleSubmit = (e) => {
  e.preventDefault();
  setIsLoading(true); // Show loader

  const formDataToSend = new FormData();
  formDataToSend.append('name', formData.name);
  formDataToSend.append('email', formData.email);
  formDataToSend.append('subject', formData.subject);
  formDataToSend.append('message', formData.message);

  fetch(scriptURL, { method: 'POST', body: formDataToSend })
    .then(response => {
      console.log('Success!', response);
      alert('Thank you for your message! We will get back to you soon.');
      setFormData({ name: '', email: '', subject: '', message: '' });
    })
    .catch(error => {
      console.error('Error!', error.message);
      alert('Oops! Something went wrong. Please try again later.');
    })
    .finally(() => {
      setIsLoading(false); // Hide loader
    });
};



  
  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-header">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-subtitle">
            Get in touch with our team for any questions or support you need.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div className="contact-text">
                  <h3>Address</h3>
                  <p>Delhi, India</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div className="contact-text">
                  <h3>Email</h3>
                  <p>support@instaheed.com</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </div>
                <div className="contact-text">
                  <h3>Phone</h3>
                  <p>+91 8700325425</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <h2>Send us a Message</h2>
            <form name="submit-to-google-sheet" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              
              {isLoading ? (
  <button type="button" className="cta-button loading" disabled>
    Sending...
  </button>
) : (
  <button type="submit" className="cta-button primary">
    Send Message
  </button>
)}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

// Privacy Policy Page Component
export const Privacy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-subtitle">Last updated: January 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Information We Collect</h2>
            <p>
             Certain visitors to Instaheed’s websites choose to interact with Instaheed in ways that require Instaheed to gather personally-identifying information. We are not ask for personal details for Clients Like – Instagram Accounts details user name, and passwords and emails not any single details we don’t ask, Because we are consultant to solve our clients Issue. The amount and type of information that Instaheed gathers depends on the nature of the interaction. For example, we ask visitors who sign up at  to provide a username and email address. Those who engage in transactions with Instaheed are asked to provide additional information, including as necessary the personal and financial information required to process those transactions. In each case, Instaheed collects such information only in so far as is necessary or appropriate to fulfill the purpose of the visitor’s interaction with Instaheed. Instaheed does not disclose personally-identifying information other than as described below. And visitors can always refuse to supply personally-identifying information, with the caveat that it may prevent them from engaging in certain website-related activities.
            </p>
          </section>

          <section className="legal-section">
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send technical notices and support messages</li>
              <li>Communicate with you about products, services, and events</li>
              <li>Monitor and analyze trends and usage</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Information Sharing</h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. We may share 
              your information only in the following circumstances:
            </p>
            <ul>
              <li>With your consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and safety</li>
              <li>In connection with business transfers</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Data Security</h2>
            <p>
              We implement appropriate security measures to protect your information against unauthorized 
              access, alteration, disclosure, or destruction. However, no method of transmission over 
              the internet is 100% secure.
            </p>
          </section>
          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at 
              support@instaheed.com or through our contact page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

// Terms and Conditions Page Component
export const Terms = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1 className="legal-title">Terms and Conditions</h1>
          <p className="legal-subtitle">Last updated: January 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Acceptance of Terms</h2>
            <p>
             Welcome to InstaHeed. These Terms and Conditions govern your use of our website and services. By accessing or using our services, you agree to be bound by these terms. ” We are not affiliated with instagram, meta,or any of its service”.
            </p>
          </section>

          <section className="legal-section">
            <h2>Service Description</h2>
            <p>
              InstaHeed provides Instagram security, growth, optimization services and security consultancy. Our services 
              include but are not limited to profile audits, security assessments, growth strategies, 
              and technical support.
            </p>
          </section>
          <section className="legal-section">
            <h2>Service Limitations</h2>
            <p>
              While we strive to provide excellent service, we cannot guarantee specific results 
              or outcomes. Instagram's policies and algorithms may change, affecting service delivery. 
              We are not responsible for actions taken by Instagram that may affect your account.
            </p>
          </section>

          <section className="legal-section">
            <h2>Payment Terms</h2>
            <p>
              Payment for services is due in advance. All fees are non-refundable unless otherwise 
              stated in our refund policy. Prices are subject to change with notice.
              Consultation Appointment Payments for services must be made in advance as per the pricing displayed on our website.
              InstaHeed reserves the right to modify prices at any time.
            </p>
          </section>

          <section className="legal-section">
            <h2>Limitation of Liability</h2>
            <p>
              InstaHeed shall not be liable for any indirect, incidental, special, consequential, 
              or punitive damages, including without limitation, loss of profits, data, or use.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Information</h2>
            <p>
              For any questions regarding these Terms and Conditions, please contact us at 
              support@instaheed.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

// Refund and Cancellation Policy Page Component
export const Refund = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1 className="legal-title">Refund and Cancellation Policy</h1>
          <p className="legal-subtitle">Last updated: January 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Refund Policy</h2>
            <p>
              This Refund and Cancellation Policy outlines the conditions under which users of InstaHeed may be eligible for refunds and the process for cancellations.
            </p>
          </section>

          <section className="legal-section">
            <h2>Consultation Fees</h2>
            <p>Consultation fees are charged for providing expert advice or initial guidance on Instagram Profile Audit & related issues.</p>
            <p>These fees are non-refundable under any circumstances, as they cover the time and expertise of our consultants.</p>
            
          </section>

          <section className="legal-section">
            <h2>Refund Eligibility for Services</h2>
            <p>Refunds are only applicable if InstaHeed fails to deliver the promised Guidance or security service as per the agreed scope.</p>
            <p>No refund will be provided if the user fails to follow the instructions provided for consultation.</p>
           
          </section>

          <section className="legal-section">
            <h2>Subscription Plans</h2>
            <p>Users may cancel their subscription plans at any time. However, no refund will be provided for the remaining period of the subscription.</p>
          
          </section>

          <section className="legal-section">
            <h2>Cancellation Process</h2>
            <p>
              Users may cancel any service request before our team begins processing it. Once the service is in progress, no cancellation or refund is allowed.
            </p>
          </section>

          <section className="legal-section">
            <h2>Refund Request Process</h2>
            <p>Users seeking a refund must contact InstaHeed at support@instaheed.com within seven (7) days of service completion.</p>
            <p>Our team will review the request and provide a response within five (5) business days.</p>
            
          </section>

          <section className="legal-section">
            <h2>Changes to Refund and Cancellation Policy</h2>
            <p>
              InstaHeed reserves the right to modify this Refund and Cancellation Policy at any time. Changes will be notified on our website.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              For any questions about refunds or cancellations, please contact us at 
              support@instaheed.com or through our contact page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};